const BASE_KEYS_WITH_ALT = new Set([
  'employee',
  'incidentLocation',
  'causaInmediata1',
  'causaInmediata2',
  'causaInmediata3',
  'causaBasica1',
  'causaBasica2',
  'causaBasica3',
]);

export function getIncidentAltCommentForKeyPointer(
  incidentResponse: any,
  keyPointer: string | null | undefined,
): string | undefined {
  if (!incidentResponse || !keyPointer) return undefined;
  const base = String(keyPointer).replace(/^incident_/, '');
  if (!BASE_KEYS_WITH_ALT.has(base)) return undefined;
  const altKey = `${base}Alt`;
  const v = incidentResponse[altKey];
  if (v == null || String(v).trim() === '') return undefined;
  return String(v).trim();
}

export function applyIncidentAltCommentPrefillToPregunta(
  pregunta: any,
  incidentResponse: any,
): void {
  if (!pregunta?.tieneComentario || !incidentResponse) return;
  if (pregunta.comentario != null && String(pregunta.comentario).trim() !== '') return;
  const t = getIncidentAltCommentForKeyPointer(incidentResponse, pregunta.keyPointer);
  if (t == null) return;
  pregunta.comentario = t;
}
